import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { CatalogRepositoryToken } from '../../di/tokens';
import type { ApplyProductPerkBatchInput } from '../../domain/entities/catalog.entity';

export function useProductPerks(productId: string) {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'product-perks', productId],
    queryFn: () => repository.listProductPerks(productId),
    enabled: !!productId,
    retry: false,
  });
}

/**
 * Aplica o diff inteiro do produto. Sem `retry`: o lote é "ou tudo, ou nada" e o
 * 422 por índice é resposta final, não falha transitória a repetir.
 */
export function useApplyProductPerkBatch(productId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(CatalogRepositoryToken);
  return useMutation({
    mutationFn: (input: ApplyProductPerkBatchInput) =>
      repository.applyProductPerkBatch(productId, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['catalog', 'product-perks', productId],
      });
    },
  });
}
